/**
 * @graphql agg
 */
import { graphql } from 'react-relay';

export const PremiumTrialEotQuery = graphql`
	query PremiumTrialEotQuery {
		license {
			billingSourceSystem
			trialEndDate
		}
	}
`;
